'use client'

import { useMedia } from '@/shared/lib'
import { Drawer, DrawerContent, DrawerTitle, DrawerTrigger } from '@/shared/ui/drawer'
import { ContactForm } from '@/widgets/Contact/ContactForm'
import * as React from 'react'
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from '@/shared/ui/dialog'
import { ModalBlockDto } from '@/shared/api/strapi/requests/getModalsBlock'
import { GetLanguageMenuSettingsDto } from '@/shared/api/strapi/requests'
import { ReactNode } from 'react'

export const ContactModal = ({
  children,
  dataSettings,
  modalsBlock,
}: {
  children: ReactNode
  dataSettings: GetLanguageMenuSettingsDto['dataSettings']
  modalsBlock: ModalBlockDto
}) => {
  const isMobile = useMedia('(max-width: 768px)')
  if (isMobile) {
    return (
      <Drawer>
        <DrawerTrigger asChild>{children}</DrawerTrigger>
        <DrawerContent aria-description={'Contact me form'} aria-describedby={undefined}>
          <DrawerTitle hidden>Contact me form</DrawerTitle>
          <div className={'flex flex-col items-center gap-12 px-8 py-6'}>
            <ContactForm settings={dataSettings} modalBlock={modalsBlock} />
          </div>
        </DrawerContent>
      </Drawer>
    )
  }
  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent>
        <DialogTitle hidden>Contact me form</DialogTitle>
        <div className={'flex flex-col items-center justify-center gap-12 px-8 py-6'}>
          <ContactForm settings={dataSettings} modalBlock={modalsBlock} />
        </div>
      </DialogContent>
    </Dialog>
  )
}
